<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-11-02 15:30:44
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-15 19:52:49
 * @FilePath: \seller.sviptrader.com\src\views\teamManage\accountManage\components\handoverDrawer\tobeHanded\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="nav flex-row mt-8">
			<span class="mr-32 fz-14">交接对象</span>
			<el-radio-group @input="switchTabs" v-model="switchActive">
				<el-radio v-for="(item, index) in tabList" :key="index" :label="item.filed">{{ item.name }}（{{ relayWaitRelay[item.filed] }}）</el-radio>
			</el-radio-group>
		</div>
		<div class="mt-32 mb-22 pl-14">
			<el-checkbox v-model="selectAll" @change="handleAllCheckBox">
				<p class="color-gy-8 fz-14 ml-2">
					全选
					<span class="color-p-4">{{ total }}</span> 个{{ activeName }}
					<span style="font-weight: 400" class="color-gy-7 fz-12">(选中所有页面的{{ activeName }})</span>
				</p>
			</el-checkbox>
		</div>
		<div class="table mt-24 gray-table-header">
			<multi-table
				v-loading="loading"
				ref="multiTable"
				:columns="tableLabel"
				@gePartnerList="gePartnerList"
				:page="pageInfo"
				:list="list"
				:options="{ selectable: true, rowKey: 'rowKeyId' }"
				:total="total"
				:selectionChange="handleSelectionChange"
				:selectable="selectable"
				:reserveSelection="true"
				:stickyHeader="false"
				:class="tableClass"
			>
				<empty slot="empty">
					<div slot="desc">暂无待移交{{ activeName }}</div>
				</empty>
			</multi-table>
		</div>
	</div>
</template>
<script>
import { todoAnchorList, todoProductList, todoInstitutionList, relayWaitRelayNum } from '@/api/teamManage';
import empty from '@/views/common/empty/index.vue';
import columns from './columns';
export default {
	components: {
		empty,
	},
	props: {
		user_id: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			loading: false,
			total: 0,
			selectList: [],
			active: 1,
			list: [],
			relayWaitRelay: {},
			switchActive: 'anchor_count',
			selectAll: false,
			selectAllSelectable: false,
		};
	},
	computed: {
		tabList() {
			let obj1 = { name: '达人', params: 1, filed: 'anchor_count' };
			let obj2 = { name: '团长', params: 2, filed: 'institution_count' };
			let obj3 = { name: '商品', params: 3, filed: 'product_count' };
			return [obj1, obj2, obj3];
		},
		isDaren({ active }) {
			return active === 1;
		},
		isHead({ active }) {
			return active === 2;
		},
		isProduct({ active }) {
			return active === 3;
		},
		activeName({ isDaren, isHead }) {
			return isDaren ? '达人' : isHead ? '团长' : '商品';
		},
		tableLabel({ isDaren, isHead, isProduct }) {
			const arr = [{ ...columns.descInfo }, columns.cooperate_count, columns.sample_count];
			if (isDaren) {
				arr[0].isDaren = true;
				arr.push(columns.cooperate_status_name);
			}
			if (isHead) {
				arr[0].isHead = true;
				arr.push(columns.authority_id);
			}
			if (isProduct) {
				arr[0].isProduct = true;
				arr.push(columns.shop_name);
			}
			return arr;
		},

		tableClass() {
			return this.selectAllSelectable ? 'tobeHanded-table' : '';
		},
	},
	methods: {
		async getList() {
			const { isDaren, isHead, user_id, pageInfo } = this;
			this.loading = true;
			const temSelectAllSelectable = this.selectAllSelectable;
			try {
				temSelectAllSelectable && this.handleAllCheckBox(false);
				if (isDaren) {
					const {
						list = [],
						page: { item_total = 0 },
					} = await todoAnchorList({ user_id, ...pageInfo });
					this.list = list.map(item => {
						return { ...item, rowKeyId: item.anchor_id };
					});
					this.total = item_total;
					this.loading = false;
				} else if (isHead) {
					const {
						list = [],
						page: { item_total = 0 },
					} = await todoInstitutionList({ user_id, ...pageInfo });
					this.list = list.map(item => {
						return { ...item, rowKeyId: item.team_institution_id };
					});
					this.total = item_total;
					this.loading = false;
				} else {
					const {
						list = [],
						page: { item_total = 0 },
					} = await todoProductList({ userId: user_id, ...pageInfo });
					this.list = list.map(item => {
						return { ...item, rowKeyId: item.id };
					});
					this.total = item_total;
					this.loading = false;
				}
				temSelectAllSelectable && this.handleAllCheckBox(true);
			} catch (e) {
				this.loading = false;
			}
		},
		async relayWaitRelayNum() {
			const { user_id } = this;
			const data = await relayWaitRelayNum({ user_id });
			this.relayWaitRelay = data;
		},
		init() {
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
			};
			this.getList();
			this.relayWaitRelayNum();
		},
		selectable() {
			return !this.selectAllSelectable;
		},
		handleSelectionChange(val) {
			this.selectList = val;
			this.$emit('selectionChange', val, this.total);
		},
		handleAllCheckBox(val) {
			this.$refs['multiTable'].$refs['baseTable'].$refs['table'].clearSelection();
			val && this.$refs['multiTable'].$refs['baseTable'].$refs['table'].toggleAllSelection();
			this.$emit('changeSelectAll', val);

			this.selectAll = val;
			setTimeout(() => {
				this.selectAllSelectable = val;
			}, 100);
		},
		switchTabs(val) {
			this.clear();
			this.handleAllCheckBox(false);
			this.selectAllSelectable = false;
			const { params } = this.tabList.find(item => item.filed === val);
			this.active = params;
			this.getList();
			this.$emit('returnActive', params);
		},
		clear() {
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
			};
			this.total = 0;
		},
		reset() {
			this.handleAllCheckBox(false);
			this.switchActive = 'anchor_count';
			this.active = 1;
		},
		gePartnerList(val) {
			this.pageInfo.page_index = val.page_index;
			this.pageInfo.page_size = val.page_size;
			this.getList();
		},
	},
};
</script>
<style lang="less" scoped>
.nav {
	display: flex;
	align-items: center;

	.pane {
		border: 1px solid #eaebf0;

		padding: 6px 27px;
	}
	.pane {
		border-width: 1px 0 1px 1px;
	}
	.pane:last-child {
		border-width: 1px;
	}
}
</style>
<style lang='less'>
.tobeHanded-table {
	.el-table__header-wrapper {
		.el-checkbox {
			display: none;
		}
	}
}
.tobeHanded-desc-info {
	.cell {
		padding-left: 0px !important;
	}
}
</style>
